'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _getDisplayName = require('helpers/getDisplayName');

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (ModalToConnect, modalKey) {
  var _class, _temp;

  var ConnectedModal = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ConnectedModal, _Component);

    function ConnectedModal() {
      (0, _classCallCheck3.default)(this, ConnectedModal);
      return (0, _possibleConstructorReturn3.default)(this, (ConnectedModal.__proto__ || (0, _getPrototypeOf2.default)(ConnectedModal)).apply(this, arguments));
    }

    (0, _createClass3.default)(ConnectedModal, [{
      key: 'render',
      value: function render() {
        var modal = this.props.modal;
        var children = modal.children,
            props = (0, _objectWithoutProperties3.default)(modal, ['children']);


        if (!modal) return null;

        return _react2.default.createElement(
          ModalToConnect,
          props,
          children
        );
      }
    }]);
    return ConnectedModal;
  }(_react.Component), _class.displayName = 'modal-connected-' + (0, _getDisplayName2.default)(ModalToConnect), _class.propTypes = {
    modal: _react.PropTypes.object
  }, _class.defaultProps = {
    modal: {}
  }, _temp);


  var mapStateToProps = function mapStateToProps(state) {
    return { modal: state.modals[modalKey] };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(ConnectedModal);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Modals/connectModal/connectModal.jsx
// module id = 1637
// module chunks = 0